module.exports = __webpack_public_path__ + "66363754ca53ec0a9bab39e26e260a42.png";